module.exports = __webpack_public_path__ + "static/media/pieces-with-diff-edges-img.357528a4.svg";